
import { format } from 'date-fns'
import { mapGetters } from 'vuex'
import LicenseIcon from '@/components/icons/LicenseIcon.vue'
import SearchIcon from '@/components/icons/SearchIcon.vue'

export default {
  // eslint-disable-next-line vue/component-definition-name-casing
  name: 'v-custom-file',
  components: {
    LicenseIcon,
    SearchIcon,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['type', 'value', 'obj'],
  data() {
    return {
      openDialog: false,
      tabs: 0,
      fileToUpload: null,
      saveToDocuments: null,
      documentType: 'documents',
      searchInput: null,
      documents: [],
      documentOptions: [
        { id: 'documents', text: 'Mis documentos' },
        { id: 'documentsFinals', text: 'Documentos oficiales' },
        { id: 'certs', text: 'Certificados' },
      ],
      itemsPerPage: 6,
      state: 'init',
      disableLoad: false,
      firstVisible: null,
      lastVisible: null,
      loading: false,
      selectedDocument: null,
      documentName: null,
    }
  },
  computed: {
    rules() {
      let rules = []
      if (this.value === null || this.value === undefined) {
        rules = [!!this.value || this.$t('required')]
      }
      return rules
    },
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    validUpload() {
      if (this.tabs === 'tab-1') {
        return (
          this.validUploadFile &&
          this.fileToUpload !== null &&
          (this.saveToDocuments === false ||
            (this.saveToDocuments === true && this.documentName))
        )
      } else {
        return this.validSelectedFile && this.selectedDocument !== null
      }
    },
    validUploadFile() {
      const maxFileSize = this.obj.schema.maxFileSize
        ? this.obj.schema.maxFileSize
        : 2
      const acceptedFiles =
        this.obj.schema.acceptedFiles.length > 0
          ? this.obj.schema.acceptedFiles
          : null

      let fileExtension = ''
      const nameArray = this.fileToUpload?.name.split('.')
      if (nameArray && nameArray.length > 0) {
        fileExtension = nameArray[nameArray.length - 1]
      }

      return (
        this.fileToUpload?.size < maxFileSize * 1e6 &&
        (acceptedFiles
          ? acceptedFiles.includes(this.fileToUpload?.type) ||
            acceptedFiles.includes(fileExtension)
          : true)
      )
    },
    validSelectedFile() {
      const maxFileSize = this.obj.schema.maxFileSize
        ? this.obj.schema.maxFileSize
        : 2
      const acceptedFiles =
        this.obj.schema.acceptedFiles.length > 0
          ? this.obj.schema.acceptedFiles
          : null
      return (
        this.selectedDocument?.size < maxFileSize * 1e6 &&
        (acceptedFiles
          ? acceptedFiles.includes(this.selectedDocument?.mime) ||
            acceptedFiles.includes(this.selectedDocument?.type)
          : true)
      )
    },
    ...mapGetters({
      user: 'users/user',
    }),
  },
  async mounted() {
    await this.get()
  },
  methods: {
    removeInput() {
      this.$emit('input', null)
    },
    // Limpia los filtros y realiza la búsqueda
    reset() {
      this.documents = []
      this.state = 'init'
      this.lastVisible = null
      this.firstVisible = null
      this.get()
    },
    cleanData() {
      this.saveToDocuments = null
      this.fileToUpload = null
      this.tabs = 0
      this.searchInput = null
      this.selectedDocument = null
    },
    // Función que le da formato a una fecha
    formatDate(val) {
      if (val != null) {
        const isValidDate = Date.parse(val)

        if (!isNaN(isValidDate)) {
          val = new Date(val)
          return format(new Date(val), 'dd/MM/yyyy')
        } else {
          return format(
            new Date((val.seconds || val._seconds) * 1000),
            'dd/MM/yyyy'
          )
        }
      }
    },
    async get() {
      const self = this
      this.loading = true
      let query = null

      let ref = null

      let collectionName = this.documentType

      let path = ''

      if (this.user.company) {
        path = 'companies'
      } else {
        path = 'users'
      }

      // Si se esta inicializando, y se estan buscando los certificados
      // agregamos el certificado de identidad digital
      if (
        this.documentType === 'certs' &&
        this.state === 'init' &&
        this.firstVisible === null &&
        this.lastVisible === null
      ) {
        await self.$fire.firestore
          .collection('certificates')
          .where('id_user', '==', self.user.uid)
          .where('is_certified', '==', true)
          .limit(1)
          .get()
          .then((certIdentidad) => {
            if (certIdentidad.docs.length > 0) {
              self.documents.push({
                ...certIdentidad.docs[0].data(),
                title: certIdentidad.docs[0].data().title,
                createdAt: certIdentidad.docs[0].data().created,
                type: self.$t('identidad-digital'),
                statusDocument: 'Vigente',
                size: 0,
                mime: 'application/pdf',
              })
            }
          })
      }

      if (this.documentType === 'certs') {
        collectionName = 'documentsFinals'
      }

      if (self.user.uid) {
        ref = this.$fire.firestore
          .collection(path)
          .doc(self.user.uid)
          .collection(collectionName)
          .where('statusDocument', '==', 'Vigente')
          .orderBy('createdAt', 'desc')

        if (this.searchInput !== null) {
          ref = ref.where('title', '==', this.searchInput)
        }

        if (this.documentType === 'certs') {
          ref = ref.where('is_certified', '==', true)
        }
      }

      if (ref !== null) {
        if (this.state === 'init') {
          query = ref.endBefore(this.lastVisible).limit(this.itemsPerPage)
        } else if (this.state === 'next' && this.firstVisible) {
          query = ref.startAfter(this.lastVisible).limit(this.itemsPerPage)
        }

        await query
          .get()
          .then((querySnapshot) => {
            this.firstVisible = querySnapshot.docs[0]
            this.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]

            if (
              querySnapshot.docs.length < this.itemsPerPage ||
              querySnapshot.docs.length === 0
            ) {
              this.disableLoad = true
            } else {
              this.disableLoad = false
            }

            if (collectionName === 'documentsFinals') {
              querySnapshot.forEach(function (doc) {
                self.documents.push({
                  id: doc.id,
                  ...doc.data(),
                  mime: 'application/pdf',
                  size: 0,
                })
              })
            } else {
              querySnapshot.forEach(function (doc) {
                self.documents.push({ id: doc.id, ...doc.data() })
              })
            }

            self.loading = false
          })
          .catch((error) => {
            self.loading = false
            // eslint-disable-next-line no-console
            console.error(this.$t('error-getting-documents'), error)
          })
      } else {
        this.loading = false
      }
    },
    save() {
      if (this.tabs === 'tab-0') {
        this.$emit('input', {
          file: this.selectedDocument,
          selectedOption: 'portadocumentos',
          documentType: this.documentType,
        })
      } else {
        this.$emit('input', {
          file: this.fileToUpload,
          selectedOption: 'pc',
          saveToDocuments: this.saveToDocuments,
          documentName: this.documentName,
        })
      }
      this.cleanData()
    },
  },
}
